import React, { useEffect, useState} from "react";
import {Modal} from "react-bootstrap";
import {TextField, InputLabel, Select, MenuItem, FormControl, Tooltip, IconButton } from "@mui/material"
import HelpCenter from '@mui/icons-material/HelpCenter';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import DoneIcon from '@mui/icons-material/Done';
import useAxiosProtect from "../../../../hooks/useAxiosProtect";

const ElectricityModal = props => {
    const axiosProtect = useAxiosProtect();

    const site_id = parseInt(window.location.href.split('/').slice(-1))

    const utilityType = "electricity";
    const [year, setYear] = useState('');
    const [month, setMonth] = useState('');
    const [electricity, setElectricity] = useState('kwh');
    const [totalElec, setTotalElec] = useState('');
    const [elecCost, setElecCost] = useState('');
    const [totalDemand, setTotalDemand] = useState('');
    const [demandCost, setDemandCost] = useState('');
    const [demand, setDemand] = useState('kw');
    const [powerFactor, setPowerFactor] = useState(0.9);
    const [invoice, setInvoice] = useState('');
    const [globalAdjust, setGlobalAdjust] = useState('');
    const [currencies, setCurrencies] = useState('cad');
    const [page, setPage] = useState(1);
    const [cdd, setCdd] = useState('');

    const [yearErr, setYearErr] = useState('');
    const [monthErr, setMonthErr] = useState('');
    const [invoiceErr, setInvoiceErr] = useState('');
    const [elecErr, setElecErr] = useState('');


    const costTip = 'If N/A or unknown, enter 0.';
    const monthTip = 'Choose the closet month to the metering period and ensure consistency';
        

    const handleYear = (event) => setYear(event.target.value);
    const handleMonth = (event) => setMonth(event.target.value);
    const handleElectricty = (event) => {
        setElectricity(event.target.value );
    };
    const handleTotalElec = (event) => setTotalElec(event.target.value);
    const handleElecCost = (event) => setElecCost(event.target.value);
    const handleCdd = (event) => setCdd(event.target.value);
    const handleTotalDemand = (event) => setTotalDemand(event.target.value);
    const handleDemandCost = (event) => setDemandCost(event.target.value);
    const handleDemand = (event) => {
        setDemand(event.target.value );
    };
    const handlePowerFactor = (event) => setPowerFactor(event.target.value);
    const handleInvoice = (event) => setInvoice(event.target.value);
    const handleGlobalAdjust = (event) => setGlobalAdjust(event.target.value);
    const handleCurrencies = (event) => {
        setCurrencies(event.target.value );
    };


    useEffect(() => {
            if (props.reading.id) {
                setYear(props.reading.year || '');
                setMonth(props.reading.month || '');
                setElectricity(props.reading.electricity_units || 'kwh');
                setTotalElec(props.reading.total_electricity || '');
                setElecCost(props.reading.electricity_cost || '');
                setDemand(props.reading.demand_units || 'kw');
                setTotalDemand(props.reading.total_demand || 'kw');
                setDemandCost(props.reading.demand_cost || '');
                setCdd(props.reading.cdd_18c || '');
                setPowerFactor(props.reading.power_factor || 0.9);
                setGlobalAdjust(props.reading.global_adjustment || '');
                setInvoice(props.reading.total_bill_cost || '');
                setCurrencies(props.reading.currency || 'cad');
            } 
        },[props.reading]);


    const createOrUpdateUtilityReading = async () => {
        try {

            let response;
            if (props.reading.id) {
                const payload = {
                    site_id: site_id,
                    electricity_units: electricity,
                    total_electricity: parseFloat(totalElec),
                    electricity_cost: parseFloat(elecCost),
                    demand_units: demand,
                    total_demand: parseFloat(totalDemand),
                    demand_cost: parseFloat(demandCost),
                    power_factor: parseFloat(powerFactor),
                    total_bill_cost: parseFloat(invoice),
                    cdd_18c: parseInt(cdd),
                    global_adjustment: parseFloat(globalAdjust),
                    month: parseInt(month),
                    year: parseInt(year),
                    start_date: "2024-04-01",
                    end_date: "2024-05-02",
                };

                response = await axiosProtect.put(`/u/utilities?utilityType=${utilityType}&id=${props.reading.id}`, payload);
            } else {
                const payload = {
                    site_id: site_id,
                    electricity_units: electricity,
                    total_electricity: parseFloat(totalElec),
                    electricity_cost: parseFloat(elecCost),
                    demand_units: demand,
                    total_demand: parseFloat(totalDemand),
                    demand_cost: parseFloat(demandCost),
                    power_factor: parseFloat(powerFactor),
                    total_bill_cost: parseFloat(invoice),
                    global_adjustment: parseFloat(globalAdjust),
                    month: parseInt(month),
                    year: parseInt(year),
                    start_date: "2024-04-01",
                    end_date: "2024-05-02",
                };

                response = await axiosProtect.post(`/u/utilities?utilityType=${utilityType}`, payload);
                props.onReadingCreated(response.data);

            }
            
            
            
        
            console.log("Success:", response.data);
            props.onClose(); // Close the modal on success
    
        } catch (err) {
            console.error("Error:", err.response?.data || err.message);
        }
    };

    const validateInitPage = () => {
        let isValid = true;
        if (year === '') {
            setYearErr('Invalid');
            isValid = false;
        }

        if (month === '') {
            setMonthErr('Invalid');
            isValid = false;
        }

        if (invoice === '') {
            setInvoiceErr('Invalid');
            isValid = false;
        }
        return isValid;
    }

    const validateSecondPage = () => {
        let isValid = true;
        if (totalElec === '') {
            setElecErr('Invalid');
            isValid = false;
        }
        return isValid;
}

    const incrementPage = () => {
        if(page === 1 && validateInitPage()){
            setPage(page + 1);

        }else if(page === 2 && validateSecondPage()){
            createOrUpdateUtilityReading()

        }
    }
  
    return (
        <Modal 
            show={true} 
            onHide={props.onClose} 
            backdrop="static"
            centered
            className="opp-modal-root"
            backdropClassName="opp-modal-backdrop"
            dialogClassName="opp-modal-cw"
        >
            <Modal.Header closeButton>
                <Modal.Title>{props.reading.id ? 'Update Electricity Utility Readings' : 'Add Electricity Utility Readings'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                {page === 1 &&
                <>
                <TextField fullWidth id="outlined-basic" label="Year" variant="outlined" type="number" 
                    value={year} 
                    onChange={handleYear} 
                    error={yearErr !== ''}
                    helperText={yearErr}
                    className='field-full' />

                <div className='field-row-full-mb'>
                    <FormControl fullWidth className='field-full'>
                        <InputLabel id="demo-simple-select-label">Month</InputLabel>
                            <Select labelId="demo-simple-select-label" id="demo-simple-select" defaultValue="m3"
                                label="Water Units"
                                value={month}
                                error={monthErr !== ''}
                                helperText={monthErr}
                                onChange={handleMonth}
                                MenuProps={{ disablePortal: true }}
                                    >
                                    <MenuItem value={1}>January</MenuItem>
                                    <MenuItem value={2}>February</MenuItem>
                                    <MenuItem value={3}>March</MenuItem>
                                    <MenuItem value={4}>April</MenuItem>
                                    <MenuItem value={5}>May</MenuItem>
                                    <MenuItem value={6}>June</MenuItem>
                                    <MenuItem value={7}>July</MenuItem>
                                    <MenuItem value={8}>August</MenuItem>
                                    <MenuItem value={9}>September</MenuItem>
                                    <MenuItem value={10}>October</MenuItem>
                                    <MenuItem value={11}>November</MenuItem>
                                    <MenuItem value={12}>December</MenuItem>
                            </Select>
                    </FormControl>

                    <Tooltip title={monthTip} className='field-tooltip-col' slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 1 }} className='help-icon-btn'>
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </ div> 
                <div className='field-row-full-mb'>
                    <TextField fullWidth id="outlined-basic" label="Total Invoice Cost ($)" variant="outlined" type="number" 
                        value={invoice} 
                        error={invoiceErr !== ''}
                        helperText={invoiceErr}
                        onChange={handleInvoice}  
                        className='field-full' />

                    <Tooltip title={costTip} className='field-tooltip-col' slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 1 }} className='help-icon-btn'>
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </ div> 
                <FormControl fullWidth className='field-full'>
                                    <InputLabel id="demo-simple-select-label">Currency</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        defaultValue="cad"
                                        label="Currency"
                                        value={currencies}
                                        onChange={handleCurrencies}
                                        MenuProps={{ disablePortal: true }}
                                    >
                                        <MenuItem value="cad">CAD</MenuItem>
                                        <MenuItem value="usd">USD</MenuItem>
                                        <MenuItem value="mex">Mex$</MenuItem>
                                        <MenuItem value="gdp">GBP</MenuItem>
                                        <MenuItem value="eur">EUR</MenuItem>
                                    </Select>
                                </FormControl>
                
                

                </>}
                {page === 2 &&
                <>
                <FormControl fullWidth className='field-full'>
                    <InputLabel id="demo-simple-select-label">Electricity Units</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        defaultValue="kwh"
                        label="Electricity Units"
                        value={electricity}
                        onChange={handleElectricty}
                        MenuProps={{ disablePortal: true }}
                    >
                    <MenuItem value="kwh">kWh</MenuItem>
                    </Select>
                </FormControl>
                <div className='field-row-full-mb'>
                <TextField 
                    fullWidth 
                    id="outlined-basic" 
                    label="Total Electricity Reading" 
                    type="number" 
                    variant="outlined" 
                    error={elecErr !== ''}
                    helperText={elecErr} 
                    value={totalElec} 
                    onChange={handleTotalElec} 
                    className='field-full' />

                    <Tooltip title={costTip} className='field-tooltip-col' slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 1 }} className='help-icon-btn'>
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </ div> 
                
                <div className='field-row-full-mb'>
                <TextField 
                    fullWidth 
                    id="outlined-basic" 
                    label="Total Electricity Cost ($)" 
                    type="number" 
                    variant="outlined" 
                    value={elecCost} 
                    onChange={handleElecCost} 
                    className='field-full' />

                    <Tooltip title={costTip} className='field-tooltip-col' slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 1 }} className='help-icon-btn'>
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </ div> 
               
                <div className='field-row-full-mb'>
                <TextField 
                    fullWidth 
                    id="outlined-basic" 
                    label="Total Demand KW" 
                    type="number" 
                    variant="outlined"
                    value={totalDemand} 
                    onChange={handleTotalDemand}  
                    className='field-full' />

                    <Tooltip title={costTip} className='field-tooltip-col' slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 1 }} className='help-icon-btn'>
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </ div> 
                
                <div className='field-row-full-mb'>
                <TextField 
                    fullWidth 
                    id="outlined-basic" 
                    label="Total Demand KW Cost ($)" 
                    type="number" 
                    variant="outlined" 
                    value={demandCost} 
                    onChange={handleDemandCost} 
                    className='field-full' />

                    <Tooltip title={costTip} className='field-tooltip-col' slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 1 }} className='help-icon-btn'>
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </ div> 
                
                <FormControl fullWidth className='field-full'>
                    <InputLabel id="demo-simple-select-label">Demand Units</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Demand Units"
                        value={demand}
                        onChange={handleDemand}
                        MenuProps={{ disablePortal: true }}
                    >
                    <MenuItem value="kw">kW</MenuItem>
                    <MenuItem value="kva">kVA</MenuItem>
                    </Select>
                </FormControl>

                <div className='field-row-full-mb'>
                <TextField 
                    fullWidth 
                    id="outlined-basic" 
                    label="Power Factor" 
                    variant="outlined"
                    type="number"
                    value={powerFactor} 
                    onChange={handlePowerFactor}  
                    className='field-full' />

                    <Tooltip title={costTip} className='field-tooltip-col' slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 1 }} className='help-icon-btn'>
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </ div> 
                
                
                
                <div className='field-row-full-mb'>
                <TextField 
                    fullWidth 
                    id="outlined-basic" 
                    label="Global Adjustment" 
                    type="number" 
                    variant="outlined"
                    value={globalAdjust} 
                    onChange={handleGlobalAdjust}  
                    className='field-full' />

                    <Tooltip title={costTip} className='field-tooltip-col' slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 1 }} className='help-icon-btn'>
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </ div> 

                {props.reading.id &&
                    <div className='field-row-full-mb'>
                    <TextField  
                        fullWidth 
                        id="outlined-basic" 
                        label="CDD Baseline" 
                        type="number" 
                        variant="outlined"
                        value={cdd} 
                        onChange={handleCdd} 
                        className='field-full' />
    
                        <Tooltip title={costTip} className='field-tooltip-col' slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                            <IconButton sx={{ m: 1 }} className='help-icon-btn'>
                                <HelpCenter/>
                            </IconButton>
                        </Tooltip>
                    </ div> 
                }
                </>}
            </Modal.Body>
            <Modal.Footer>
                <div className='field-row-full'>
                    {page > 1 && <IconButton aria-label="site-create-back" onClick={() => setPage(page - 1)}>
                        <ArrowBackIcon />
                    </IconButton>}

                    <div className='field-spacer-lg'></div>

                    <IconButton aria-label="site-create-next" onClick={() => incrementPage()}>
                        {page < 2 ? <ArrowForwardIcon /> : <DoneIcon />}
                    </IconButton>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default ElectricityModal;